import { render, staticRenderFns } from "./TurnList.vue?vue&type=template&id=6658a366&scoped=true&"
import script from "./TurnList.vue?vue&type=script&lang=js&"
export * from "./TurnList.vue?vue&type=script&lang=js&"
import style0 from "./TurnList.vue?vue&type=style&index=0&id=6658a366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658a366",
  null
  
)

export default component.exports